import { connect } from 'react-redux';

import { client } from '@biw/contests-core';

import { ONBOARDING } from 'dux/router/types';
import { getUserAuthenticated } from 'dux/user/selectors';
import { getCurrentRouteType } from 'dux/router/selectors';

export const mapStateToProps = (state: any) => ( {
    authenticated: getUserAuthenticated( state ),
    clientLogo: client.selectors.getClientLogo( state ),
    hideNav: getCurrentRouteType( state ) === ONBOARDING,
} );

export default connect( mapStateToProps );
